import { axiosInstance } from "@helpers/axios-instance";
import type { HouseholdContact, DataAwareResponse } from "../types/types";
import { useQueryWithValidation } from "./useQueryWithValidation";

export type Gift = {
  externalCode: string;
  name: string;
  amount: number;
  comments: string;
  recipientId: string;
  year: number;
  recipientIds?: string[];
  amounts?: number[];
  commentsArr?: string[];
};

type GiftsData = {
  gifts: Gift[];
  contacts: HouseholdContact[];
};

export function useGifts(householdExternalCode: string) {
  return useQueryWithValidation({
    queryKey: ["gifts", householdExternalCode],
    queryFn: async () => {
      const data = await axiosInstance({
        method: "GET",
        url:  `Salesforce/Gifts/${householdExternalCode}`,
      });
      return data.data as DataAwareResponse<GiftsData>;
    },
    enabled: !!householdExternalCode,
  });
}
